module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/quotas/quota-batchs/components/quota-transfer-target-form/quota-transfer-target-form.component.css
// module id = ./src/app/quotas/quota-batchs/components/quota-transfer-target-form/quota-transfer-target-form.component.css
// module chunks = main